import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import acceptedJobApi from '../../APIs/jobs';
import {
  Button,
  PageHeader,
  Pagination,
  Typography,
} from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
// import { VIEW_REVIEW_JOB_DETAIL_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { PaginationType } from '../../types';
import { humanReadableDate, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { ReviewContainerStyled } from './styles';

type Props = {};

const Reviews = (_props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const pagination = useSelector((state: RootState) => state.pdfs.pagination);

  const jobReviews = useSelector((state: RootState) => state.pdfs.data);

  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'PDF Sent Date' },
      { key: 'name', label: 'Technician Name' },
      {
        key: 'email',
        label: 'Email Address',
      },
      {
        key: 'pdfName',
        label: 'PDF Name',
      },

      {
        key: 'action',
        label: 'Action',
      },
    ],
    body: Array.isArray(jobReviews)
      ? jobReviews
          .filter((item) =>
            item.review.some((reviewItem: any) => reviewItem.isActive === true)
          )
          ?.map((review) => {
            return {
              id: review._id,
              date: humanReadableDate(review.createdAt),
              name: review?.createdBy?.fullName,
              email: review?.createdBy?.emailAddress,
              pdfName: 'pdf1',
              action: (
                <Button
                  variant="secondary"
                  onClick={() => navigate(review?._id)}
                  style={{
                    backgroundColor: theme.colors.blueLight,
                    border: `1px solid ${theme.colors.blueLight}`,
                  }}
                >
                  View Details
                </Button>
              ),
            };
          })
      : [],
  };

  const getAllJobsReview = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        acceptedJobApi.getAllJobReviews({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllJobsReview(pagination);
  }, []);

  const handlePagination = (updatedParams: PaginationType) => {
    getAllJobsReview(updatedParams);
    dispatch(Store.Actions.update('pdfs.pagination', updatedParams));
  };

  const debouncedFunction = useCallback(
    debounce((myParams) => getAllJobsReview(myParams), 500),
    []
  );

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  return (
    <ReviewContainerStyled>
      <PageHeader
        pageTitle={<Typography variant="title">PDF Listing</Typography>}
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <Table tableData={tableData} />

      <Pagination
        activePage={pagination?.page}
        handlePagination={handlePagination}
        limit={pagination?.limit}
        totalCount={pagination?.totalData || 0}
      />
    </ReviewContainerStyled>
  );
};

export default Reviews;
